import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function DecreaseIcon({
    size = ICON_DEFAULT_SIZE,
    color = ICON_DEFAULT_COLOR, ...rest
}: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path d="M6.98863 12L17.0114 12" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <path
                d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
                fill={color}/>
            <path d="M7 12L17.0227 12" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    );
}

export default DecreaseIcon;
